/**
 * 
 */
(function() {
	"use strict";
	angular.module("cbl.common").directive(
			"finNumeric",
			[
					'$parse',
					'$filter',
					function($parse, $filter) {
						return {
							restrict : "A",
							require : 'ngModel',
							link : function(scope, elem, attrs, ctrl) {
								var maxValue = attrs.cblMax;
								var minValue = attrs.cblMin;
								var isPrezzoInput = attrs.cblPrezzo === 'true' ? true : false;
								var precision = attrs.cblPrecision ? attrs.cblPrecision.split(",") : null;
								if (precision) {
									if (precision.length < 2 || parseFloat(precision[0]) === NaN || parseFloat(precision[1]) === NaN) {
										precision = null;
									}
								}

								// For DOM -> model validation
								ctrl.$parsers
										.unshift(function(value) {
											if (!value || value === '') {
												return value;
											}
											value = manipolaNumerico(value);
											// comma to decimal
											value = (value) ? value.toString().trim().replace('.', '').replace(",", ".") : null;
											if (maxValue) {
												maxValue = maxValue.replace(",", ".");
												// controllo su valore massimo
												ctrl.$setValidity("cblMax", !(parseFloat(value) > parseFloat(maxValue)));
											}
											if (minValue) {
												minValue = minValue.replace(",", ".");
												// controllo su valore minimo
												ctrl.$setValidity("cblMin", !(parseFloat(value) < parseFloat(minValue)));
											}
											if (precision) {
												// controllo di precisione
												var valPrecision = value.indexOf(".");
												var segno = value.indexOf("-") + 1;
												if (valPrecision === -1) {
													// controllo scala non
													// necessario
													ctrl.$setValidity("cblPrecisione",
															(value.length - segno) <= (parseFloat(precision[0]) - parseFloat(precision[1])));
												} else {
													ctrl.$setValidity("cblPrecisione",
															(valPrecision - segno) <= (parseFloat(precision[0]) - parseFloat(precision[1]))
																	&& ((value.length - segno) - valPrecision - 1) <= parseFloat(precision[1])
																	&& valPrecision < (value.length - 1));
												}
											}
											return parseFloat(value);
										});

								// For model -> DOM validation
								ctrl.$formatters
										.unshift(function(value) {
											if (!value || value === '') {
												return value;
											}
											// decimal to comma
											value = (value) ? value.toString().replace(".", ",") : null;
											value = manipolaNumerico(value);
											if (maxValue) {
												maxValue = maxValue.replace(".", ",");
												// controllo su valore massimo
												ctrl.$setValidity("cblMax", !(parseFloat(value) > parseFloat(maxValue)));
											}
											if (minValue) {
												minValue = minValue.replace(".", ",");
												// controllo su valore minimo
												ctrl.$setValidity("cblMin", !(parseFloat(value) < parseFloat(minValue)));
											}
											if (precision) {
												// controllo di precisione
												var valPrecision = value.indexOf(",");
												var segno = value.indexOf("-") + 1;
												if (valPrecision === -1) {
													// controllo scala non
													// necessario
													ctrl.$setValidity("cblPrecisione",
															(value.length - segno) <= (parseFloat(precision[0]) - parseFloat(precision[1])));
												} else {
													ctrl.$setValidity("cblPrecisione",
															(valPrecision - segno) <= (parseFloat(precision[0]) - parseFloat(precision[1]))
																	&& ((value.length - segno) - valPrecision - 1) <= parseFloat(precision[1])
																	&& valPrecision < (value.length - 1));
												}

												// Add zero
												var decimal = parseFloat(precision[1]);
												if (decimal > 0) {
													if (valPrecision === -1) {
														value += ",";
													} else {
														decimal -= value.split(",")[1].length;
													}
													while (decimal > 0) {
														value += "0";
														decimal--;
													}
												}
											}
											// formatta migliaia
											var splitedValue = value.split(',');
											var counter = 0;
											for (var i = splitedValue[0].length - 1; i >= 1; i--) {
												counter++;
												if (counter % 3 == 0) {
													splitedValue[0] = splitedValue[0].slice(0, i) + '.' + splitedValue[0].slice(i);
												}
											}
											value = splitedValue[0] + (splitedValue.length === 1 ? '' : (',' + splitedValue[1]));
											return value;
										});

								var manipolaNumerico = function(value) {
									if (!value) {
										return value;
									}
									var validi = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '-' ];

									if(isPrezzoInput){
										validi.push('.')
									}

									var lung = value.length;
									for (var i = lung - 1; i >= 0; i--) {
										var ch = value.charAt(i);
										if (i !== 0 && ch === '-') {
											// rimuovo il segno negativo se non
											// è all'inizio
											value = value.substring(0, i) + value.substring(i + 1);
											continue;
										}
										var valoreValido = false;
										for ( var j in validi) {
											if (ch === validi[j]) {
												valoreValido = true;
												break;
											}
										}
										if (!valoreValido) {
											value = value.substring(0, i) + value.substring(i + 1);
										}
									}

									if(isPrezzoInput){
										value = value.replace('.',',');
									}

									var primoDecimale = value.indexOf(',');
									if (primoDecimale >= 0) {
										lung = value.length;
										for (var k = lung - 1; k > primoDecimale; k--) {
											var chd = value.charAt(k);
											if (chd == ",") {
												value = value.substring(0, k) + value.substring(k + 1);
											}
										}
									}

									return value;
								}

								elem.on("keyup", function(data) {
									var start = this.selectionStart, end = this.selectionEnd;
									var value = this.value;

									this.value = manipolaNumerico(value);
									this.setSelectionRange(start, end);

								});

							}
						}
					} ]);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finNumeric/finNumericDrct.js
 ** module id = 11
 ** module chunks = 0 1 2
 **/